import { Routes } from '@angular/router';
import { roleGuard } from '../../../lib/guards/admin-role.guard';
import { permissionGuard } from '../../../lib/guards/permission.guard';

const guards = [roleGuard('ADMIN_MASTER'), permissionGuard('HOME_SCREEN$READ')];

const listLoader = () =>
  import(
    './components/smart/design-list-page/design-list-page.component'
  ).then((m) => m.DesignListPageComponent);

const detailLoader = () =>
  import(
    './components/smart/homepage-builder-design-detail-page/homepage-builder-design-detail-page.component'
  ).then((m) => m.HomepageBuilderDesignDetailPageComponent);

export const homepageBuilderDesignRoutes: Routes = [
  {
    path: 'homepage-master/home/design',
    data: { title: 'Homepage Design' },
    canActivate: guards,
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full' },
      {
        path: 'list',
        loadComponent: listLoader,
        children: [
          {
            path: ':id',
            loadComponent: detailLoader,
            data: { title: 'Homepage Design Detail' },
          },
        ],
      },
    ],
  },
];
